import { wordlists } from 'bip39';

export function shortAddress(address: string, length: number) {
  if (!address) return '';

  const first = address.slice(0, length);
  const last = address.slice(-length);

  return `${first}...${last}`;
}

export function isEqualsIgnoringCase(a?: string, b?: string) {
  return typeof a === 'string' && typeof b === 'string' && a.toLowerCase() === b.toLowerCase();
}

export function isMnemonic(text: string) {
  const words = text.trim().split(' ');

  if (words.length !== 12 && words.length !== 24) {
    return false;
  }

  return words.every((item) => wordlists.EN.find((mnemonicWord) => mnemonicWord === item));
}

export function isMnemonicContain(text: string) {
  if (!text) return false;

  const words = text
    .trim()
    .split(' ')
    .map((w) => w.trim())
    .filter((w) => w.length > 0);

  if (words.length >= 8) {
    const n = (words.length / 4) * 3;

    let numMnemonics = 0;

    words.forEach((item) => {
      if (wordlists.EN.find((mnemonicWord) => mnemonicWord === item)) {
        numMnemonics += 1;
      }
    });

    return numMnemonics >= n;
  }
  return false;
}

export function formatDate(date: Date) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const targetDate = new Date();
  targetDate.setHours(0, 0, 0, 0);

  const remainingDays = Math.ceil((targetDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  const formattedDate = `${month} ${day}th, ${year} ${hours}:${minutes}:${seconds} ${remainingDays === 0 ? 'D-Day' : `(D${remainingDays})`}`;

  return formattedDate;
}
